// Strona Zgody – tylko zaakceptowane zgody; przy braku: "Brak wyrażonych zgód"
// @ts-nocheck

import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';

import { reduxActions, useDispatch, useSelector } from 'store';
import { useGetUserContract } from 'api';
import { PageTitle } from 'components/controls';
import { SingleConsent } from 'pages/Consent/components';

import styles from 'theme/pages/MessageSettings/MessageSettings.module.scss';

const Consent = () => {
  const { t } = useTranslation();
  const { profile } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const { data: userContractData, refetch: refetchContracts } = useGetUserContract({
    page: 1,
    limit: 999
  });

  const acceptedContracts = (userContractData?.items || []).filter(
    (contract) => contract.has_active_agree === true
  );

  useEffect(() => {
    dispatch(
      reduxActions.setBreadcrumbs([
        { name: t('Dashboard'), path: '/dashboard' },
        { name: t('Zgody') }
      ])
    );
  }, [dispatch, t]);

  useEffect(() => {
    const footer = document.querySelector('footer');
    if (footer && !footer.id) {
      footer.id = 'footer';
    }
  }, []);

  const scrollToFooter = (e) => {
    e.preventDefault();
    const footer = document.querySelector('footer');
    if (footer) footer.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className={classnames(styles.componentWrapper, 'StylePath-Pages-MessageSettings')}>
      <PageTitle title={t('Zgody')} />

      <div className={styles.notifications}>
        {profile?.id && acceptedContracts.length > 0 ? (
          acceptedContracts.map((contract) => (
            <SingleConsent
              key={contract.id}
              contractId={contract.id}
              enabled={contract.has_active_agree}
              name={contract.testimony}
              refetchContracts={refetchContracts}
            />
          ))
        ) : profile?.id ? (
          <p className={styles.emptyMessage}>{t('Brak wyrażonych zgód')}</p>
        ) : null}

        <div className={styles.withdrawMessage}>
          {t('Jeśli chcesz wycofać zgodę, prosimy o skontaktowanie się z')}{' '}
          <a href="#footer" onClick={scrollToFooter} className={styles.footerLink}>
            <strong>{t('Biurem Obsługi Klienta')}</strong>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Consent;
